import useCompanyRole from './useCompanyRole';

export default function useRoleTrackingKeys(companySlug: string) {
  const { roles } = useCompanyRole(companySlug);

  return roles.map(role => `r-${role}`);
}
